
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-nft-5",
      function () {
        return require("private-next-pages/academy/learn-nft-5/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-nft-5"])
      });
    }
  